import styles from './EventCard.module.scss';
import classNames from 'classnames';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_LinkWithIcon } from 'ui/components/1-atoms/Action/LinkWithIcon/LinkWithIcon';
import { UI_RichText } from 'ui/components/1-atoms/RichText/RichText';
import IconArrow from 'ui/icons/icon_right_arrow.svg';
import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';

export interface EventCardProps {
	className?: string;
	image?: {
		url: string;
		altText?: string;
	};
	kicker?: string;
	title: string;
	date: {
		label: string;
		value: string;
	};
	location?: {
		label: string;
		value: string;
	};
	price?: {
		label: string;
		value: string;
	};
	link?: {
		url: string;
		target?: string;
		name: string;
	};
}
export const UI_EventCard = ({ className, image, kicker, title, date, location, price, link }: EventCardProps) => {
	return (
		<div className={classNames(styles.EventCard, className)}>
			{image?.url && (
				<div className={styles.EventCard_imageContainer}>
					<UI_Picture url={image.url} altText={image?.altText ? image.altText : ''} />{' '}
				</div>
			)}
			{kicker && <p className={styles.EventCard_kicker}>{kicker}</p>}
			<UI_Heading className={styles.EventCard_title} style="lg">
				{title}
			</UI_Heading>
			<div className={classNames(styles.EventCard_item, styles.EventCard_item___date)}>
				<p className={styles.EventCard_itemLabel}>{date.label}</p>
				<p className={styles.EventCard_itemValue}>{date.value}</p>
			</div>
			{location && (
				<div className={styles.EventCard_item}>
					<p className={styles.EventCard_itemLabel}>{location.label}</p>
					<UI_RichText className={styles.EventCard_itemValue} content={location.value} noBottomMargin />
				</div>
			)}
			{price && (
				<div className={styles.EventCard_item}>
					<p className={styles.EventCard_itemLabel}>{price.label}</p>
					<p className={styles.EventCard_itemValue}>{price.value}</p>
				</div>
			)}
			{link?.url && (
				<div className={styles.EventCard_link}>
					<UI_LinkWithIcon
						url={link.url}
						target={link.target}
						icon={
							<span className={styles.EventCard_linkIcon}>
								<IconArrow />
							</span>
						}
						text={link.name}
					/>
				</div>
			)}
		</div>
	);
};
